/* Component Dependencies */
var hotelDirectoryRegionalNavTemplate = require('templates/hotelDirectoryRegionalNav.hbs');
var AriesComponent = require('libs/aries-component');
var GoogleApi = require('libs/google-api');
var iconOverlay=require('libs/baidumaps/icon-overlay');
var baiduCluster=require('libs/baidumaps/map-cluster');
//var MapHandler = require('libs/google-map-handler');
var baiduInfoWindow=require('libs/baidumaps/info-window');
var MarkerClustererPlus = require('marker-clusterer-plus');
var MapConfig = require('libs/googleMapConfig');
var PubSub = require('libs/pub-sub');
var LoadingIndicator = require('utils/loading-indicator');
var $ = require('jquery');
var Popup = require('libs/popup');

AriesComponent.create({
    type: 'hotelDirectoryRegionalNav',

    template: {
        'hotelDirectoryRegionalNav': hotelDirectoryRegionalNavTemplate
    },

    subscribe: {
        'SELECT_DIRECTORY_REGION': 'setRegion',
        'REGIONAL_NAV_TRIGGER': 'regionalNavClick',
        'TOGGLE_HOTEL_DIRECTORY_REGION_NAV': 'toggleHotelDirectoryRegionNav'
    },

    events: {
        'click .js-regional-nav-trigger': 'regionalNavClick'

    },

    unBindEvents: function ($) {

    },

    mapData: {
        properties: [],
        imageUrl: {},
        isAddressPin: false
    },

    bindEvents: function () {
        var _self = this;
        window.$('.m-navigation').on('responsiveMenu-init');
        if(_self.$el.hasClass('js-baidu-map'))
            _self.initBaidu();
        else
            _self.initGoogleApi();
        _self.$el.find('.js-regional-nav').on('click', _.bind(_self.regionalNavClick, _self));
        if (_self.$el.find('.js-popup').length > 0) {
            _self.getLocationDataUrl = _self.$el.find('.l-click-search-cont').data().url;
            _self.regionalNavPopup = new Popup({
                selector: '.js-regional-nav-trigger',
                sourceBlock: '.l-click-search-cont',
                mainClass: 'm-modal t-modal-med',
                ajaxLoaded: false
            });
            _self.regionalNavPopup.register();

            _self.$el = $('.is-click-search');
            _self.clickToSearch = true;
            _self.loadingIndicator = new LoadingIndicator(_self.$el.find('.js-regional-map'));
        }

        $(document).trigger('GLOBAL_ELEMENTS_REINIT');
    },

    regionalNavTriggerClick: function (e) {
        var _self = this;
        _self.$el.parent().find('.js-regional-nav-trigger:first-child').trigger('click');
    },

    regionalNavClick: function (e) {
        var regionCode = e.currentTarget.dataset.region;
        this.pubsub.publish('SELECT_DIRECTORY_REGION', [regionCode]);
        this.pubsub.publish('SELECT_DIRECTORY_REGION_DETAIL', [regionCode]);
    },

    setBaiduMap: function(markersBaidu){
        for(i in markersBaidu)
            this.bmap.addOverlay(markersBaidu[i]);
    },

    createBaiduMarker: function(markerData){
        var _self=this;
        var propCount = (typeof markerData.count == "Number") ? markerData.count.toString() : markerData.count;
        var label= new BMap.Label('<div class="baidu-marker"><span>'+propCount+'</span></div>',{offset:new BMap.Size(-3,-3)});
        label.propCount = propCount;
        label.setStyle({
            background: 'none',
            color: '#fff',
            contentAlign:'center',
            border: 'none'
          });
        var marker= new BMap.Marker(new BMap.Point(markerData.long,markerData.lat));
        marker.customData=markerData;
        _self.options = {
          Width: 250, // information window width
          Height: 80, // information window height
          enableMessage: true   // set the allow information window to send short messages
        };
        
        marker.setLabel(label);
        marker.addEventListener('click',function(){
            _self.onBaiduMarkerClick(this);
        });
        this.markersBaidu.push(marker);
    },
    
    updateClustererInfoWindow: function(currentClusters){
        for(var i=0;i<currentClusters.length;i++)
        {
            if(currentClusters[i]._isReal)
            {
                var locationList=document.createElement('div');
                var index=0;
                var txt='<ul>';
                currentClusters[i]._markers.forEach(function(marker){
                    txt+='<li><a href="'+(marker.customData.href || '#')+'" data-index="'+index+'">'+marker.customData.location+'('+marker.customData.count+') </a></li>';
                })
                txt+='</ul>';
                locationList.innerHTML=txt;
                locationList.className='js-regional-map';
                this.addMouseoverHandler(locationList,currentClusters[i]._clusterMarker);    
            }
        }
    },
    
    initBaidu: function () {
        var _self=this;
        _self.bmap = new BMap.Map("baidumap");
        _self.markersBaidu = [];
        _self.pin = _self.$el.find('.js-regional-map').data().img;

        _self.bmap.enableScrollWheelZoom(true);
        _self.bmap.centerAndZoom(new BMap.Point(-94.00,45.00), 4);
        var offset = {
            type: BMAP_NAVIGATION_CONTROL_SMALL,
            anchor: BMAP_ANCHOR_TOP_LEFT
        };
        _self.bmap.addControl(new BMap.NavigationControl(offset));
        _self.bmap.addControl(new BMap.OverviewMapControl());
        options = { offset: new BMap.Size(150, 5) };
        _self.bmap.addControl(new BMap.ScaleControl(options));
        _self.bmap.addEventListener('zoomend',function(){
            if(_self.markerClusterer){
                var currentClusters=_self.markerClusterer.getClusters();
                _self.updateClustererInfoWindow(currentClusters);
            }
        });
        _self.bmap.addEventListener('moveend',function(){
            if(_self.markerClusterer){
                var currentClusters=_self.markerClusterer.getClusters();
                _self.updateClustererInfoWindow(currentClusters);
            }
        });
        setTimeout(
        function () {
            _self.pubsub.publish('SELECT_DIRECTORY_REGION', ['asia']);
        }, 400);

    },

    ctsCreateMarkerBaidu: function (markerData) {
        var _self = this;
        var label = markerData.location.toString() + " (" + markerData.count.toString() + ")";
        // var icon = _self.pin.cityPin;

        var marker = new google.maps.Marker({
            position: {
                lat: Number(markerData.lat),
                lng: Number(markerData.long)
            },
            icon: icon,
            label: {
                text: label,
                color: "white",
                fontWeight: "bold",
                fontSize: "12",
                fontFamily: "proxima-nova, Helvetica, Arial, sans-serif"
            }
        });

        marker.location = markerData.location;
        marker.count = markerData.count;
        marker.ndx = _self.markers.length;
        marker.info = markerData;
        marker.clickToSearch = true;

        _self.bounds.extend(marker.getPosition());
        _self.markers.push(marker);

        google.maps.event.addListener(marker, 'click', function () {
            _self.onCtsMarkerClick(this);
        });
        google.maps.event.addListener(marker, 'mouseover', function () {
            marker.setZIndex(_self.markers.length + 1);
        });
        google.maps.event.addListener(marker, 'mouseout', function () {
            marker.setZIndex(marker.ndx);
        });
    },

    createMarker: function (markerData) {
        var _self = this;
        var label = (typeof markerData.count == "Number") ? markerData.count.toString() : markerData.count;
        var icon = _self.pin.regionPin;
        var marker = new google.maps.Marker({
            position: {
                lat: Number(markerData.lat),
                lng: Number(markerData.long)
            },
            icon: icon,
            label: {
                text: label,
                color: "white",
                fontWeight: "bold",
                fontSize: "12",
                fontFamily: "proxima-nova, Helvetica, Arial, sans-serif"
            }
        });
        if (markerData.href) {
            marker.href = markerData.href;
        }

        marker.count = markerData.count;

        if (markerData.location) {
            marker.location = markerData.location;
        }
        if (markerData.country) {
            marker.country = markerData.country;
        }
        if (markerData.state) {
            marker.state = markerData.state;
        }
        if (markerData.countryLabel) {
            marker.countryLabel = markerData.countryLabel;
        }

        _self.bounds.extend(marker.getPosition());

        google.maps.event.addListener(marker, 'click', function () {
            _self.onMarkerClick(this);
        });

        _self.markers.push(marker);
    },

    ctsCreateMarker: function (markerData) {
        var _self = this;
        var label = markerData.location.toString() + " (" + markerData.count.toString() + ")";
        var icon = _self.pin.cityPin;

        var marker = new google.maps.Marker({
            position: {
                lat: Number(markerData.lat),
                lng: Number(markerData.long)
            },
            icon: icon,
            label: {
                text: label,
                color: "white",
                fontWeight: "bold",
                fontSize: "12",
                fontFamily: "proxima-nova, Helvetica, Arial, sans-serif"
            }
        });

        marker.location = markerData.location;
        marker.count = markerData.count;
        marker.ndx = _self.markers.length;
        marker.info = markerData;
        marker.clickToSearch = true;

        _self.bounds.extend(marker.getPosition());
        _self.markers.push(marker);

        google.maps.event.addListener(marker, 'click', function () {
            _self.onCtsMarkerClick(this);
        });
        google.maps.event.addListener(marker, 'mouseover', function () {
            marker.setZIndex(_self.markers.length + 1);
        });
        google.maps.event.addListener(marker, 'mouseout', function () {
            marker.setZIndex(marker.ndx);
        });
    },

    // Sets the map on all markers in the array.
    setMapOnAll: function (map) {
        for (var i = 0; i < this.markers.length; i++) {
            this.markers[i].setMap(map);
        }
    },

    // Removes the markers from the map, but keeps them in the array.
    clearMarkers: function () {
        this.setMapOnAll(null);
        if (this.markerClusterer) {
            this.markerClusterer.clearMarkers();
        }
    },

    // Shows any markers currently in the array.
    showMarkers: function () {
        var _self = this;
        _self.setMapOnAll(_self.map);
    },

    // Deletes all markers in the array by removing references to them.
    deleteMarkers: function () {
        var _self= this;
        if(_self.$el.hasClass('js-baidu-map')) {
            if(this.markerClusterer)
                this.markerClusterer.clearMarkers();
            this.markersBaidu = [];
        } else {
            this.clearMarkers();
            this.markers = [];
        }      
    },

    addMouseoverHandler: function(content, markerCluster){
        markerCluster.addEventListener('mouseover', function(e) {
            openInfo(content, e);
          });
    },

    openInfo: function(content, e){
        var _self=this;
        var point = e.target;
        point = new BMap.Point(point.getPosition().lng, point.getPosition().lat);
        var infoWindow = new baiduInfoWindow.BMapLib.InfoBox(content, this.options); // create infowindow object
        if(_self.$el.hasClass('BMAP_pop'))
        {
            _self.$el.find('BMap_pop').addClass('gm-style-iw','gm-style-iw-c');
        }
        _self.bmap.openInfoWindow(infoWindow, point); //open info window
    },

    onBaiduMarkerClick:function(marker){
        if (this.clickToSearch) {
            this.getLocationData({
                country: marker.customData.country,
                stateProvince: marker.customData.state,
                location: marker.customData.location,
                countryLabel: marker.customData.countryLabel,
                count: marker.customData.count
            });
        } else {
            window.location = marker.customData.href;
        }
    },

    onMarkerClick: function (marker) {
        this.hideClusterInfo();
        if (this.clickToSearch) {
            this.getLocationData({
                country: marker.country,
                stateProvince: marker.state,
                location: marker.location,
                countryLabel: marker.countryLabel,
                count: marker.count
            });
        } else {
            window.location = marker.href;
        }
    },

    onCtsMarkerClick: function (marker) {
        var _self = this;
        _self.hideClusterInfo();
        _self.pubsub.publish('UPDATE_CLICK_TO_SEARCH_DATA', [marker]);
        _self.pubsub.publish('POPUP_CLOSE');
    },

    setRegionBaidu: function(regionData,markerData, regionEl){
        var _self=this;
        var minLat=9999,maxLat=-9999,minLong=9999,maxLong=-9999,averageLat=0,averageLong=0;
        for (var country in regionData) {
            if (country != "_") {
                if (typeof regionData[country].state == "undefined") {
                    markerData = regionData[country];
                    markerData.country = country;
                    markerData.countryLabel = regionData[country].countryLabel;
                    minLat=parseFloat(minLat)>parseFloat(markerData.lat)?markerData.lat:minLat;
                    maxLat=parseFloat(maxLat)<parseFloat(markerData.lat)?markerData.lat:maxLat;
                    minLong=parseFloat(minLong)>parseFloat(markerData.long)?markerData.long:minLong;
                    maxLong=parseFloat(maxLong)<parseFloat(markerData.long)?markerData.long:maxLong;
                    _self.createBaiduMarker(markerData);
                } else {
                    for (var state in regionData[country].state) {
                        if (state != "_") {
                            markerData = regionData[country].state[state];
                            markerData.country = country;
                            markerData.countryLabel = regionData[country].countryLabel;
                            markerData.state = state;
                            minLat=parseFloat(minLat)>parseFloat(markerData.lat)?markerData.lat:minLat;
                            maxLat=parseFloat(maxLat)<parseFloat(markerData.lat)?markerData.lat:maxLat;
                            minLong=parseFloat(minLong)>parseFloat(markerData.long)?markerData.long:minLong;
                            maxLong=parseFloat(maxLong)<parseFloat(markerData.long)?markerData.long:maxLong;
                            _self.createBaiduMarker(markerData);
                        }
                    }
                }
            }
        }

        averageLat=(parseFloat(maxLat)+parseFloat(minLat))/2.0;
        averageLong=(parseFloat(maxLong)+parseFloat(minLong))/2.0;
        if(regionData.hasOwnProperty('AU')) {
            _self.bmap.centerAndZoom(new BMap.Point(regionData.AU.long,regionData.AU.lat), 4);
        } if(Object.keys(regionData).length === 1) {
            // regionData will have a single default value when countryDetails empty
            var defaultLatLong = regionEl ? regionEl.data().latlong : false;
            if(defaultLatLong){
                _self.bmap.centerAndZoom(new BMap.Point(parseFloat(defaultLatLong.long),parseFloat(defaultLatLong.lat)), 4);
            }
        } else {
            _self.bmap.centerAndZoom(new BMap.Point(averageLong,averageLat), 4);
        }
        _self._clusters=[];
        _self.markerClusterer = new baiduCluster.BMapLib.MarkerClusterer(_self.bmap, 
            {
                markers: _self.markersBaidu,
                isAverageCenter:true,
                styles: [
                    {
                      //clustered markers style
                      url: _self.pin.clustImg,
                      textColor: 'white',
                      size: new BMap.Size(70, 70)
                    }
                ]
            });
        _self.markerClusterer.setGridSize(100);
        _self.markerClusterer.setMaxZoom(7);
        _self._clusters.push(_self.markerClusterer);
    },

    setRegionGoogle: function(regionData,markerData,regionEl,region){
        var _self = this;
        for (var country in regionData) {
            if (country != "_") {
                if (typeof regionData[country].state == "undefined") {
                    markerData = regionData[country];
                    markerData.country = country;
                    markerData.countryLabel = regionData[country].countryLabel;
                    _self.createMarker(markerData);
                } else {
                    for (var state in regionData[country].state) {
                        if (state != "_") {
                            markerData = regionData[country].state[state];
                            markerData.country = country;
                            markerData.countryLabel = regionData[country].countryLabel;
                            markerData.state = state;
                            _self.createMarker(markerData);
                        }
                    }
                }
            }
        }

        if (regionEl.data().showlist) {
            _self.map.fitBounds(_self.bounds);
        } else {
            if (regionEl.data().detail) {
                _self.getLocationData({
                    country: Object.keys(regionEl.data().detail)[0]
                });
            } else {
                _self.getLocationData({ country: region });
            }
            var currentBounds = _self.bounds.toJSON();
            if(currentBounds.north === currentBounds.south && currentBounds.east === currentBounds.west) {
                _self.map.fitBounds(_self.bounds);
                _self.map.setZoom(4);
            }
        }
        _self.showMarkers();
        _self.markerClusterer.addMarkers(_self.markers);
        google.maps.event.trigger(_self.map, 'resize');

        if(Object.keys(regionData).length === 1) {
            // regionData will have a single default value when countryDetails empty
            var defaultLatLong = regionEl.data().latlong;
            if(defaultLatLong){
                _self.map.setCenter({lat: parseFloat(defaultLatLong.lat), lng: parseFloat(defaultLatLong.long)});
                _self.bounds = new google.maps.LatLngBounds();
                _self.map.setZoom(3);
            }
        }

        google.maps.event.addListenerOnce(_self.map, 'idle', function () {
            //This is to solve Marker not rendering intermittantly issue
            _self.map.panBy(1, 0);
            _self.map.panBy(-1, 0);
            if (_self.clickToSearch) {
                _self.map.fitBounds(_self.bounds);
            }
        });
    },

    setRegion: function (region) {
        var _self = this, regionEl;

        if (region) {
            regionEl = _self.$el.find('.js-region [data-region="' + region + '"]');
        } else {
            regionEl = _self.$el.find('.js-region:first-child');
            region = regionEl.find('.js-regional-nav').data().region;
        }

        var regionData = regionEl.data().detail;
        var markerData = {};

        if(_self.$el.find('.js-regional-map').data().options)
        _self.bounds = new google.maps.LatLngBounds();

        _self.deleteMarkers();

        _self.$el.find('.js-region').removeClass('active').removeClass('highlighted');
        regionEl.parent().addClass('active');
        
        if(_self.$el.hasClass('js-baidu-map'))
            _self.setRegionBaidu(regionData,markerData,regionEl);
        else
            _self.setRegionGoogle(regionData,markerData,regionEl, region);                    
    },

    initGoogleApi: function () {

        var _self = this, mapEl = _self.$el.find('#rmap');

        // Initiating Google Api

        _self.markers = [];


        var googleApi = GoogleApi.create({
            $el: mapEl,
            apiUrl: mapEl.data('options').api + "&language=" + mapEl.data('language'),
            fallback: function () { }
        });

        googleApi.initGoogleApi(function () {
            _self.map = new google.maps.Map(document.getElementById('rmap'), {
                center: {
                    lat: -34.397,
                    lng: 150.644
                },
                zoom: 8
            });
            _self.map.setOptions({
                styles: MapConfig.styledMapType
            });
            _self.geocoder = new google.maps.Geocoder();
            _self.pin = _self.$el.find('.js-regional-map').data().img;
            _self.pin.cityPin = _self.pin.cityPin || {
                url: _self.pin.pinImg,
                scaledSize: new google.maps.Size(100, 30),
                labelOrigin: new google.maps.Point(50, 12)
            }
            _self.pin.regionPin = _self.pin.regionPin || {
                path: "M 18, 18 m -18, 0 a 18,18 0 1,0 36,0 a 18,18 0 1,0 -36,0 z",
                fillColor: '#494949',
                fillOpacity: 1,
                anchor: new google.maps.Point(18, 24),
                strokeWeight: 0,
                labelOrigin: {
                    x: 18,
                    y: 18
                }
            }
            var dir = document.getElementsByTagName("html")[0].getAttribute("dir");
            if (dir === 'rtl') {
                _self.pin.regionPin.labelOrigin = { x: 12, y: 19 };
            }
            MapConfig.clusterProps.styles[0].url = _self.pin.clustImg;
            MapConfig.clusterProps.styles[0].fontFamily = "proxima-nova, Helvetica, Arial, sans-serif";
            MapConfig.clusterProps.calculator = function (markers, numStyles) {
                var index = 0;
                //var title = "Hotels";
                var count = markers.length.toString();
                var countHotels = 0;
                markers.forEach(function (o) {
                    countHotels += Number(o.count);
                });

                var dv = count;
                while (dv !== 0) {
                    dv = parseInt(dv / 10, 10);
                    index++;
                }

                index = Math.min(index, numStyles);

                return {
                    text: countHotels,
                    index: index
                };
            };

            _self.markerClusterer = new MarkerClustererPlus(_self.map, _self.markers, MapConfig.clusterProps);
            _self.infoWindow = new google.maps.InfoWindow();

            setTimeout(
                function () {
                    _self.pubsub.publish('SELECT_DIRECTORY_REGION', ['united-states']);
                }, 200);

            google.maps.event.addListener(_self.markerClusterer, "mouseover", function (e) {
                _self.showClusterInfo(e, this);
            });
            _self.map.addListener('zoom_changed', function () {
                _self.hideClusterInfo();
            });

            _self.bounds = new google.maps.LatLngBounds();
        });
    },
    showClusterInfo: function (e, cluster) {
        var _self = this,
            txt = "",
            ndx = 0;
        _self.infoWindowContentEl = document.createElement('div');

        txt = '<ul>'
        e.markers_.forEach(function (marker) {
            txt += '<li><a href="' + (marker.href || "#") + '" data-ndx="' + ndx + '">' + marker.location + " (" + marker.count + ') </a></li>';
            ndx++;
        });
        txt += '</ul>';

        _self.infoWindowContentEl.innerHTML = txt;
        _self.infoWindowContentEl.className = "l-region-info";
        _self.infoWindow.setContent(_self.infoWindowContentEl);
        _self.infoWindow.setPosition(e.center_);
        _self.infoWindow.open(_self.map);

        if (_self.clickToSearch) {
            google.maps.event.addDomListener(_self.infoWindowContentEl, 'click', (function (item) {
                item.preventDefault();
                if (e.markers_[0].clickToSearch) {
                    _self.onCtsMarkerClick(e.markers_[$(item.target).data().ndx]);
                } else {
                    _self.onMarkerClick(e.markers_[$(item.target).data().ndx]);
                }
            }));
        }
    },
    hideClusterInfo: function () {
        this.infoWindow.close();
    },
    getLocationData: function (data) {
        var _self = this;

        var context = {
            "context": {
                "localeKey": _self.getContextData().localeKey
            },
            "variation": "0.1",
            "sessionToken": _self.getSessionToken()
        }

        if (data.stateProvince) {
            context.context.state = data.stateProvince;
        }
        if (data.country) {
            context.context.country = data.country;
        }
        if (_self.loadingIndicator) {
            _self.loadingIndicator.addLoader();

            _self.makeAjaxCall({
                url: _self.getLocationDataUrl,
                contentType: 'application/json',
                method: 'POST',
                data: JSON.stringify(context),
                success: _.bind(_self.handleHotelData, _self),
                error: _.bind(_self.handleHotelDataOnError, _self, data)
            });

        }

    },
    handleHotelDataOnError: function (data) {
        this.loadingIndicator.removeLoader();
        this.onCtsMarkerClick({
            info: {
                stateProvince: data.stateProvince,
                countryDescription: data.country,
                countryLabel: data.countryLabel,
                location: data.location
            }
        });
    },
    handleHotelData: function (data) {
        var listOfProp = data.component.data.propertyList;

        var markerData = {};
        var _self = this;
        _self.loadingIndicator.removeLoader();

        _self.cities = {};

        if (listOfProp.length > 0) {
            listOfProp.forEach(function (rec) {
                if (rec.address && rec.address.city) {

                    var citiMarker = _self.cities[rec.address.city];
                    markerData = {
                        lat: Number(rec.clickToSearchbasicInfo.latitude),
                        long: Number(rec.clickToSearchbasicInfo.longitude)
                    }

                    if (citiMarker) {
                        citiMarker.lat = citiMarker.lat + markerData.lat,
                            citiMarker.long = citiMarker.long + markerData.long,
                            citiMarker.count = citiMarker.count + 1

                    } else {
                        _self.cities[rec.address.city] = {
                            lat: markerData.lat,
                            long: markerData.long,
                            count: 1,
                            city: rec.address.city,
                            stateCode: rec.address.stateCode,
                            countryCode: rec.address.countryCode,
                            countryDescription: rec.address.countryDescription,
                            countryLabel: rec.address.countryDescription,
                            location: rec.address.city
                        }
                    }
                }
            });

            if (!_.isEmpty(_self.cities)) {
                _self.deleteMarkers();
                _self.bounds = new google.maps.LatLngBounds();

                for (var citi in _self.cities) {
                    var rec = _self.cities[citi];
                    rec.lat = (rec.lat / rec.count).toString();
                    rec.long = (rec.long / rec.count).toString();
                    rec.count = rec.count.toString();
                    _self.ctsCreateMarker(rec, true);
                }

                _self.map.fitBounds(_self.bounds);

                _self.showMarkers();
                _self.markerClusterer.addMarkers(_self.markers);
                google.maps.event.trigger(_self.map, 'resize');

                google.maps.event.addListenerOnce(_self.map, 'idle', function () {
                    //This is to solve Marker not rendering intermittantly issue
                    _self.map.panBy(1, 0);
                    _self.map.panBy(-1, 0);
                });
            }
        }
    },
    toggleHotelDirectoryRegionNav: function _toggleHotelDirectoryRegionNav(isTileDisplayed) {
        var _self = this;
        isTileDisplayed === true ? _self.$el.removeClass('l-display-none').addClass('l-display-block') : _self.$el.removeClass('l-display-block').addClass('l-display-none');
    }
});
